import { useAppDispatch, useAppSelector } from '../../../../../lib/store';
import { setGroupBy } from '../../../state/annotationSlice';
import { selectGroupBy } from '../../../state/selector';

export interface UseGroupBySectionResult {
  groupBy: string;
  handleGroupByChange: (value: string) => void;
}

export const useGroupBySection = (): UseGroupBySectionResult => {
  const dispatch = useAppDispatch();
  const groupBy = useAppSelector(selectGroupBy);

  const handleGroupByChange = (value: string) => {
    dispatch(setGroupBy(value));
  };
  return { groupBy, handleGroupByChange };
};
